import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DeliveryType } from "$src/domain/projects/deliveries/DeliveryType";
import type { IDeliveryRepository } from "$src/domain/projects/deliveries/IDeliveryRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetDeliveryTypes {
    
    constructor(@inject(ServiceTokens.DeliveryRepository) private deliveryRepository: IDeliveryRepository) {}

    async execute(groupStoreId: number): Promise<DeliveryType[]> {
        return await this.deliveryRepository.getTypes(groupStoreId);
    }
}

export const GetDeliveryTypesToken = Symbol('GetDeliveryTypesToken');    
